var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeView = function SvgEyeView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.467 7.56c-1.817 1.356-3.18 2.96-3.92 3.928v.002a.827.827 0 0 0 .003 1.012l.001.002c.748.968 2.128 2.574 3.951 3.932 1.827 1.361 4.05 2.439 6.498 2.439 2.448 0 4.67-1.075 6.494-2.434 1.822-1.357 3.2-2.96 3.95-3.93l.002-.002a.828.828 0 0 0 0-1.018l-.002-.001c-.75-.97-2.128-2.574-3.95-3.93C16.67 6.2 14.448 5.124 12 5.124c-2.485 0-4.714 1.077-6.533 2.435Zm-.748-1.002C6.661 5.108 9.15 3.875 12 3.875c2.817 0 5.297 1.234 7.24 2.682 1.948 1.45 3.406 3.15 4.193 4.168a2.078 2.078 0 0 1 0 2.55c-.788 1.02-2.246 2.719-4.192 4.168-1.944 1.448-4.424 2.682-7.241 2.682-2.817 0-5.3-1.237-7.245-2.686-1.948-1.452-3.407-3.153-4.193-4.17a2.077 2.077 0 0 1-.008-2.54c.778-1.02 2.221-2.72 4.165-4.17Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.125a3.875 3.875 0 1 0 0 7.75 3.875 3.875 0 0 0 0-7.75ZM6.875 12a5.125 5.125 0 1 1 10.25 0 5.125 5.125 0 0 1-10.25 0Z",
    fill: "currentColor"
  })));
};
export default SvgEyeView;